import React from 'react';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
import { mockupUrl, offerAnchor, productName } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Hero() {
  return <section className="bg-teal-800 pb-14 md:pb-16" data-id="element-104" data-mp="9l375k8q6q7o">
      <div className="border-b border-white/10 bg-teal-950 px-4 py-2.5 text-center" data-id="element-105" data-mp="4mi319qcrmdy">
        <p className="text-[11px] font-extrabold uppercase tracking-[.3em] text-amber-300 md:text-xs" data-id="element-106" data-mp="12a0mbehn46w7">
          Bright Digital Hub
        </p>
      </div>
      <div className="mx-auto max-w-4xl px-4 pt-8 text-center md:pt-10" data-id="element-107" data-mp="xb5r1d2hkpv7">
        <h1 className="mx-auto max-w-3xl font-black uppercase leading-tight tracking-tight text-white" data-id="element-108" data-mp="s9zzhikkb8n9">
          <span className="block text-xs text-white/85 md:text-sm" data-id="element-109" data-mp="nbey3ftkqix8">
            The complete senior rehabilitation system for physical therapists
          </span>
          <span className="mt-2 block text-2xl sm:text-3xl md:text-5xl" data-id="element-110" data-mp="381xmf1kmf8br">
            Complete Senior <span className="text-amber-300" data-id="element-111" data-mp="3j8se7xjcfdo9">Balance &amp; Mobility</span> Bundle
          </span>
        </h1>

        <OfferLink className="mx-auto my-7 max-w-[300px] sm:max-w-[420px]" label={`See the ${productName} offer`} data-id="element-112" data-mp="3o85bzdbr655m">
          <img src={mockupUrl} alt={`${productName}: 5 complete professional volumes and 5 practical bonuses`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-113" data-mp="399b9bibx13tc" />
        </OfferLink>

        <p className="mx-auto max-w-2xl text-base font-black uppercase leading-relaxed text-white md:text-xl" data-id="element-114" data-mp="358zu4l2bnvp9">
          5 Complete Professional Volumes + 5 Practical Bonuses
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base" data-id="element-115" data-mp="2vievixmner6c">
          <strong className="text-white" data-id="element-116" data-mp="2hincgih9yklh">Advanced rehabilitation techniques</strong>,{' '}
          <strong className="text-white" data-id="element-117" data-mp="2lkiiu1e2bo64">step-by-step exercises</strong>,{' '}
          <strong className="text-white" data-id="element-118" data-mp="2lml98mj4njbd">structured treatment sessions</strong>, and practical clinical tools — all
          organized into one complete professional system.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base" data-id="element-119" data-mp="n98cdkmjmzmb">
          Access specialized protocols for postural control, gait retraining, functional rehabilitation, reactive
          balance, and complete treatment planning for older adults.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base" data-id="element-120" data-mp="1b04at0li8t2j">
          Every technique is organized with patient positioning, sets, repetitions, rest periods, and practical
          modifications.
        </p>
        <p className="mt-5 text-xs font-black uppercase tracking-wider text-white md:text-sm" data-id="element-121" data-mp="x1nwoolbc0ad">
          Less preparation time.{' '}
          <span className="text-amber-300" data-id="element-122" data-mp="3luia4t2z73mf">More structure in every rehabilitation session.</span>
        </p>

        <div className="mt-7" data-id="element-123" data-mp="3hq250u16s089">
          <Button href={offerAnchor} size="lg" subtext="5 complete volumes + 5 practical bonuses" data-id="element-124" data-mp="1x9b4uzsqezc1">
            Yes! I want the complete system
          </Button>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/85" data-id="element-125" data-mp="218to7r4wn2cr">
          <li className="flex items-center gap-1.5" data-id="element-126" data-mp="2b0fynl9f4xeg">
            <BookOpenIcon className="h-4 w-4 text-amber-300" aria-hidden="true" data-id="element-127" data-mp="2b20q320fs083" /> Instant Digital Access
          </li>
          <li className="flex items-center gap-1.5" data-id="element-128" data-mp="2g257qvd2z0zw">
            <ShieldCheckIcon className="h-4 w-4 text-amber-300" aria-hidden="true" data-id="element-129" data-mp="2kxu8v34r0pyb" /> 7-Day Guarantee
          </li>
        </ul>
      </div>
    </section>;
}